import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const CleaningWashingForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "15%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "450px",
      height: "100%",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const fungicidalDippingRef = useRef({});
  const [fungicidalDippingDetails, setFungicidalDippingDetails] = useState([]);
  const [fungicidalDippingClose, setFungicidalDippingClose] = useState(false);

  const [decimalPattern, setDecimalPattern] =
    localStorage.getItem("decimalPattern");
  const [integerPattern, setIntegerPattern] =
    localStorage.getItem("integerPattern");
  const [productId, setProductId] = useState();
  const [unitId, setunitId] = useState();

  const [availableAmount, setavailableAmount] = useState();

  const [employeeId, setEmployeeId] = useState();

  const [products, setProducts] = useState(false);

  const [lotQty, setLotQty] = useState(false);
  const [lotQtyUnit, setLotQtyUnit] = useState("");

  const [lotUnitId, setLotUnitId] = useState(false);

  const [tempUnit, setTempUnit] = useState();

  const [conUnit, setConUnit] = useState();

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();
  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getProducts } = useHttp();

  useEffect(() => {
    getProducts(
      {
        url: `/api/product/`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setProducts(res);
        }
      }
    );
  }, [getProducts]);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //  setUnits(res);
          //console.log(res);

          const tempUnits =
            res && res.filter((item) => item.unitTypeName == "Temperature");

          setTempUnit(tempUnits);

          const conUnits =
            res && res.filter((item) => item.unitTypeName == "Concentration");

          setConUnit(conUnits);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getLot } = useHttp();

  const { sendRequest: getStock } = useHttp();

  const [lotId, setLotId] = useState();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
        //  //console.log(data);
        setLotId(data);
      }
    );
  }, [getLot]);

  const { sendRequest: postCleaningWashing } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);
    const data = {
      cleaningWashingDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      cleaningWashingTime: frmRef.current.time.value,
      stockId: frmRef.current.lot_id.value,
      supervisorEmployeeId: frmRef.current.emp_id.value,
      detergentinWater: frmRef.current.detergent.value,
      productDetails: productDetails,
      waterTemperature: frmRef.current.water_temp.value,
      Quantity: lotQty,
      unitId: lotUnitId,
      waterTreatmentDipping: fungicidalDippingDetails,
      waxCoating: frmRef.current.wax_coating.value,
      labourHrs: frmRef.current.labour_hours.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: localStorage.getItem("warehouseId"),
      serviceId: props.sId,
    };
    //console.log(data);
    if (props.update) {
      data["cwId"] = props.update.cwId;
    }

    postCleaningWashing(
      {
        url: "/api/cleaningWashing/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        props.addForm(false);
        toast.success("Cleaning and washing data submited successfully");
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    if (props.update) {
      // frmRef.current.date.value =props.update.cwDate&& props.update.cwDate
      //   .split("/")
      //   .reverse()
      //   .join("-");
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      setProductDetails(props.update.productDetails);
      frmRef.current.time.value = props.update.cleaningWashingTime;
      frmRef.current.labour_hours.value = props.update.labourHrs;

      frmRef.current.remark.value = props.update.remark;
      frmRef.current.water_temp.value = props.update.waterTemperature;
      frmRef.current.detergent.value = props.update.detergentinWater;
      frmRef.current.wax_coating.value = props.update.waxCoating;
      setFungicidalDippingDetails(props.update.waterTreatmentDipping);
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();

    const productId = productRef.current.product_name.value;
    const productTypeName = productRef.current.product_type.value;
    const productSubTypeName = productRef.current.sub_type.value;
    const availableQuantity = productRef.current.avai_qty.value;
    const inputItemQuantity = productRef.current.used_quantity.value;
    const unit = productRef.current.unit.value;
    var productId1 = productId;

    var pdlist = productDetails.filter((item) => item.productId == productId1);

    if (parseFloat(inputItemQuantity ?? 0) <= 0) {
      toast.success("Please enter product quantity", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (pdlist.length != 0) {
      toast.success("Product already present into the list", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (
      !productId ||
      !productTypeName ||
      !productSubTypeName ||
      !availableQuantity ||
      !inputItemQuantity ||
      !unit
    ) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      setProductDetails((x) => [
        ...x,
        {
          srno:
            productDetails.length > 0
              ? productDetails[productDetails.length - 1].srno + 1
              : 1,
          productId: productRef.current.product_name.value,
          productName: productRef.current.pro_name.value,
          productTypeName: productTypeName,
          productSubTypeName: productRef.current.sub_type.value,
          availableQuantity: productRef.current.avai_qty.value,
          inputItemQuantity: productRef.current.used_quantity.value,
          unit: productRef.current.unit.value,
          unitId: productRef.current.unit_id.value,
          remark: "product 1",
          productcost: 0,
          createdBy: parseInt(localStorage.getItem("id")),
          orgId: localStorage.getItem("orgId"),
          status: 1,
          createdDate: dateString,
          warehouseId: localStorage.getItem("warehouseId"),
        },
      ]);

      //console.log(productDetails);
    }
  };

  useEffect(() => {
    if (productDetails && productDetails.length > 0) {
      // productRef.current.product_name.value = "";
      // productRef.current.product_type.value = "";
      // productRef.current.sub_type.value = "";
      // productRef.current.avai_qty.value = "";
      // productRef.current.unit.value = "";
      // productRef.current.used_quantity.value = "0";
      setunitId(0);
      setavailableAmount(0);
    }
  }, [productDetails]);

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };
  const submitFungicidalDipping = (e) => {
    e.preventDefault();
    setFungicidalDippingDetails({
      desiredTemp: fungicidalDippingRef.current.temp.value,
      tempUnitId: fungicidalDippingRef.current.temp_unit.value,
      tempUnitName: fungicidalDippingRef.current.unit_name.value,
      fungicideName: fungicidalDippingRef.current.fungicide_name.value,
      fungicideConcentration:
        fungicidalDippingRef.current.fungicide_concentration.value,
      concentrationUnitId:
        fungicidalDippingRef.current.concentration_unit.value,
      concentrationUnitName:
        fungicidalDippingRef.current.concentration_unit_name.value,

      exposureTime: fungicidalDippingRef.current.exposure_time.value,
    });

    setFungicidalDippingClose(false);
  };

  // useEffect(() => {
  //   if (fungicidalDippingClose && fungicidalDippingDetails) {
  //     fungicidalDippingRef.current.temp.value =
  //       fungicidalDippingDetails.desiredTemp || "";
  //     fungicidalDippingRef.current.temp_unit.value =
  //       fungicidalDippingDetails.tempUnit;
  //     fungicidalDippingRef.current.fungicide_name.value =
  //       fungicidalDippingDetails.fungicideName || "";
  //     fungicidalDippingRef.current.fungicide_concentration.value =
  //       fungicidalDippingDetails.fungicideConcentration || "";
  //     fungicidalDippingRef.current.concentration_unit.value =
  //       fungicidalDippingDetails.concentrationUnit;
  //     fungicidalDippingRef.current.exposure_time.value =
  //       fungicidalDippingDetails.exposureTime || "";
  //   }
  // }, [fungicidalDippingClose]);

  const handleLotIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;

    //console.log(lotId);

    const filterData = lotId && lotId.filter((item) => item.stockId == id);
    console.log(filterData);

    setLotQtyUnit(filterData && filterData[0].productunitAbbreviation);

    setLotQty(filterData && filterData[0].productQuantityBal);
    ////console.log(filterData && filterData[0].productQuantityBal+" "+filterData[0].unitAbbreviation);

    setLotUnitId(filterData && filterData[0].unitId);
  };

  const handleProductChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;

    const filterProducts =
      products && products.filter((item) => item.productId == id);
    //console.log(filterProducts);
    productRef.current.sub_type.value =
      filterProducts[0].productSubTypeName || "";
    productRef.current.product_type.value =
      filterProducts[0].productTypeName || "";

    productRef.current.pro_name.value = filterProducts[0].productName || "";
    loadStockData(id);
    setProductId(e.target.value);
  };

  const loadStockData = (id) => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      productId: id,
    };
    getStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {
        var data=myres.data
        //console.log(data);
        productRef.current.avai_qty.value = data.availableQty || 0;
        productRef.current.unit.value = data.unitName || "";
        productRef.current.unit_id.value = data.unitId || "";
      }
    );
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);

      var totalquantity = parseFloat(productRef.current.avai_qty.value);

      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  const handleUnitChange = (e) => {
    //console.log(e.target.value);

    const id = parseInt(e.target.value);

    const disTempUnit =
      tempUnit &&
      tempUnit
        .filter((item) => item.unitId == id)
        .map((item) => item.unitName)
        .join(", ");
    //console.log(disTempUnit);

    fungicidalDippingRef.current.unit_name.value = disTempUnit;
  };
  const handleConUnitChange = (e) => {
    //console.log(e.target.value);

    const id = parseInt(e.target.value);

    const conUnitName =
      conUnit &&
      conUnit
        .filter((item) => item.unitId == id)
        .map((item) => item.unitName)
        .join(", ");
    //console.log(conUnitName);

    fungicidalDippingRef.current.concentration_unit_name.value = conUnitName;
  };

  return (
    <>
      {fungicidalDippingClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">
              Water treatment Fungicidal dipping Details
            </h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setFungicidalDippingClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor={"temp"}>desired Temperature </label>
                <input
                  type={"input"}
                  id={"temp"}
                  required
                  ref={(el) => (fungicidalDippingRef.current["temp"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"temp"}>Unit </label>
                <select
                  id="temp_unit"
                  className="drop-prod form-control"
                  ref={(el) => (fungicidalDippingRef.current["temp_unit"] = el)}
                  onChange={handleUnitChange}
                >
                  <option value="">select</option>
                  {tempUnit &&
                    tempUnit.map((x, i) => (
                      <option value={x.unitId} key={i}>
                        {x.unitAbbreviation}{" "}
                      </option>
                    ))}
                </select>
                <input
                  type={"input"}
                  id={"tempunit"}
                  ref={(el) => (fungicidalDippingRef.current["unit_name"] = el)}
                  className="form-control"
                  hidden
                />
              </div>

              <div className="col-md-4">
                <label htmlFor={"fungicide_name"}>Fungicide Name</label>
                <input
                  type={"input"}
                  id={"fungicide_name"}
                  required
                  ref={(el) =>
                    (fungicidalDippingRef.current["fungicide_name"] = el)
                  }
                  className="form-control"
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-4">
                <label htmlFor={"fungicide_concentration "}>
                  Fungicide Concentration{" "}
                </label>
                <input
                  type={"input"}
                  id={"fungicide_concentration"}
                  required
                  ref={(el) =>
                    (fungicidalDippingRef.current["fungicide_concentration"] =
                      el)
                  }
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor={"concentration_unit"}>Unit</label>
                <select
                  id="concentration_unit"
                  className="drop-prod form-control"
                  ref={(el) =>
                    (fungicidalDippingRef.current["concentration_unit"] = el)
                  }
                  onChange={handleConUnitChange}
                >
                  <option value="">select</option>
                  {conUnit &&
                    conUnit.map((x) => (
                      <option value={x.unitId}>{x.unitAbbreviation}</option>
                    ))}
                </select>
                <input
                  type={"input"}
                  id={"tempunit"}
                  ref={(el) =>
                    (fungicidalDippingRef.current["concentration_unit_name"] =
                      el)
                  }
                  className="form-control"
                  hidden
                />
              </div>

              <div className="col-md-4">
                <label htmlFor={"exposure_time"}>Exposure time (sec)</label>
                <input
                  type={"input"}
                  id={"exposure_time"}
                  required
                  ref={(el) =>
                    (fungicidalDippingRef.current["exposure_time"] = el)
                  }
                  className="form-control"
                />
              </div>
            </div>
            <div className="text-center mt-3">
              <button
                className="btn btn-sm btn-primary"
                onClick={submitFungicidalDipping}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"product_name"}>Product Name</label>
              <select
                id={"itemId"}
                required
                ref={(el) => (productRef.current["product_name"] = el)}
                className="form-control"
                onChange={handleProductChange}
              >
                <option value="">Select</option>
                {products &&
                  products.map((x, i) => (
                    <option key={i} value={x.productId}>
                      {x.productName + "(" + x.itemId + ")"}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor={"sub_type"} hidden>
                Product Name
              </label>
              <input
                type={"input"}
                id={"sub_type"}
                required
                ref={(el) => (productRef.current["pro_name"] = el)}
                className="form-control"
                disabled
                hidden
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"sub_type"}> Product Sub Type</label>
              <input
                type={"input"}
                id={"sub_type"}
                required
                ref={(el) => (productRef.current["sub_type"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"product_type"}>Product Type</label>
              <input
                type={"input"}
                id={"product_type"}
                required
                ref={(el) => (productRef.current["product_type"] = el)}
                className="form-control"
                disabled
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"avai_qty"}>Available Quantity</label>
              <input
                type={"input"}
                id={"avai_qty"}
                required
                ref={(el) => (productRef.current["avai_qty"] = el)}
                className="form-control"
                readOnly
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"used_Quantity"}> Used Quantity</label>
              <input
                type={"number"}
                id={"used_quantity"}
                onChange={(e) => {
                  handleValidateQuantityChange(e);
                }}
                required
                ref={(el) => (productRef.current["used_quantity"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"unit"}>Unit</label>
              <input
                type={"text"}
                id={"unit"}
                required
                ref={(el) => (productRef.current["unit"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <input
                type={"text"}
                id={"unit"}
                required
                ref={(el) => (productRef.current["unit_id"] = el)}
                className="form-control"
                hidden
              />
            </div>
          </div>
          <br />
          <div className="col-md-3">
            <button className="btn btn-sm btn-success" onClick={submitProduct}>
              +
            </button>
          </div>
          <hr />

          <table className="table table-sm table-bordered">
            {" "}
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Product Sub Type</th>
                <th>Product Type</th>
                <th>Available Quantity</th>
                <th>Used Quantity</th>
                <th>Unit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.srno}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.productTypeName}</td>
                      <td>{itm.availableQuantity}</td>
                      <td>{itm.inputItemQuantity}</td>
                      <td>{itm.unit}</td>

                      <td>
                        <button
                          className="btn"
                          onClick={(e) => handleDelete(i, e)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div className="text-center">
            <br />
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Cleaning Washing Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={
                          props.update.cleaningWashingDate
                            ? props.update.cleaningWashingDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"time"}>{"Time"}</label>
                      <input
                        type={"time"}
                        id={"time"}
                        required
                        ref={(el) => (frmRef.current["time"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}>{"Lot id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        onChange={handleLotIdChange}
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {lotId &&
                          lotId.map((x) => (
                            <option
                              value={x.stockId}
                              selected={
                                props.update &&
                                props.update.stockId == x.stockId
                              }
                            >
                              {x.lotNo + "(" + x.productName + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-2">
                      <label htmlFor={"available_qty"}>
                        {"Available Quantity"}
                      </label>
                      <input
                        type={"number"}
                        id={"available_qty"}
                        value={lotQty}
                        autoComplete="off"
                        ref={(el) => (frmRef.current["available_qty"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-1">
                      <label htmlFor={"available_qty_unit"}>Unit</label>
                      <input
                        type={"text"}
                        id={"available_qty_unit"}
                        autoComplete="off"
                        value={lotQtyUnit}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"water_temp"}>
                        {"Water Temperature (°C)"}
                      </label>
                      <input
                        type={"number"}
                        id={"water_temp"}
                        required
                        ref={(el) => (frmRef.current["water_temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"detergent"}>
                        {"Detergent in Water "}
                      </label>
                      <input
                        type={"number"}
                        id={"detergent"}
                        required
                        ref={(el) => (frmRef.current["detergent"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"water_treatment"}>
                        {"Water treatment dipping"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"water_treatment"}
                        autoComplete="off"
                        ref={(el) => (frmRef.current["water_treatment"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          setFungicidalDippingClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"wax_coating"}>{"Wax Coating"}</label>
                      <input
                        type={"text"}
                        id={"wax_coating"}
                        required
                        ref={(el) => (frmRef.current["wax_coating"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"labour_hours"}>{"Labour Hours"}</label>
                      <input
                        type={"text"}
                        id={"labour_hours"}
                        ref={(el) => (frmRef.current["labour_hours"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CleaningWashingForm;
